import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadConfigValue } from './ReduxSlice';

// Load values when the screen using them mounts; reuse values across screens.
const useConfigValues = (...keys) => {
  const dispatch = useDispatch();
  const values = useSelector((state) => state.configValues);
  const keyList = keys.join(',');

  useEffect(() => {
    keyList.split(',').filter(Boolean).forEach((key) => {
      dispatch(loadConfigValue(key));
    });
  }, [dispatch, keyList]);

  return values;
};

export default useConfigValues;
